// V1-COMPAT: V2 builds with Propshaft, whose JsAssetUrls compiler rewrites RAILS_ASSET_URL("/x.png")
// to the digested URL at asset compile time. V1 (webpacker) has no such step, so the copied V2 trees
// get the same call as a runtime global, resolving the manifest-copied images to their webpack URLs.
import companyProfileBanner from '../../../../assets/images/company-profile-banner.png';
import expertHubDemo from '../../../../assets/images/expert-hub-demo.png';
import expertHubPoweredBy from '../../../../assets/images/expert-hub-powered-by.png';
import expertProfileBanner from '../../../../assets/images/expert-profile-banner.png';
import hybridProfileBanner from '../../../../assets/images/hybrid-profile-banner.png';
import loading from '../../../../assets/images/loading.svg';
import mediaProfileBanner from '../../../../assets/images/media-profile-banner.png';
import prProfileBanner from '../../../../assets/images/pr-profile-banner.png';
import productProfileBanner from '../../../../assets/images/product-profile-banner.png';
import qwoted100 from '../../../../assets/images/qwoted100.png';

const ASSET_URLS = {
  '/company-profile-banner.png': companyProfileBanner,
  '/expert-hub-demo.png': expertHubDemo,
  '/expert-hub-powered-by.png': expertHubPoweredBy,
  '/expert-profile-banner.png': expertProfileBanner,
  '/hybrid-profile-banner.png': hybridProfileBanner,
  '/loading.svg': loading,
  '/media-profile-banner.png': mediaProfileBanner,
  '/pr-profile-banner.png': prProfileBanner,
  '/product-profile-banner.png': productProfileBanner,
  '/qwoted100.png': qwoted100,
};

globalThis.RAILS_ASSET_URL = (path) => ASSET_URLS[path] ?? path;

export default ASSET_URLS;
